import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { CurrencyProvider } from './context/CurrencyContext';
import { AuthProvider } from './context/AuthContext';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';

// Pages
import { Home } from './pages/Home';
import { GamesDirectory } from './pages/GamesDirectory';
import { GameDetail } from './pages/GameDetail';
import { Browse } from './pages/Browse';
import { ProductDetail } from './pages/ProductDetail';
import { BoostingPage } from './pages/BoostingPage';
import { Checkout } from './pages/Checkout';
import { PaymentStatus } from './pages/PaymentStatus';
import { SellerProfile } from './pages/SellerProfile';
import { HelpCenter } from './pages/HelpCenter';
import { BlogPage } from './pages/BlogPage';
import { BecomeSeller } from './pages/BecomeSeller';
import { Legal } from './pages/Legal';

// Dashboards
import { BuyerOrders } from './pages/buyer/BuyerOrders';
import { BuyerWishlist } from './pages/buyer/BuyerWishlist';
import { BuyerMessages } from './pages/buyer/BuyerMessages';
import { SellerDashboard } from './pages/seller/SellerDashboard';
import { BoosterDashboard } from './pages/booster/BoosterDashboard';
import { AdminDashboard } from './pages/admin/AdminDashboard';

export const App: React.FC = () => {
  return (
    <ThemeProvider>
      <CurrencyProvider>
        <AuthProvider>
          <BrowserRouter>
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/games" element={<GamesDirectory />} />
                  <Route path="/games/:gameSlug" element={<GameDetail />} />
                  <Route path="/browse" element={<Browse />} />
                  <Route path="/product/:id" element={<ProductDetail />} />
                  <Route path="/boosting" element={<BoostingPage />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/checkout/status/:orderId" element={<PaymentStatus />} />
                  <Route path="/seller/:sellerId" element={<SellerProfile />} />
                  <Route path="/help" element={<HelpCenter />} />
                  <Route path="/blog" element={<BlogPage />} />
                  <Route path="/become-seller" element={<BecomeSeller />} />
                  <Route path="/legal" element={<Legal />} />

                  {/* Buyer Routes */}
                  <Route path="/buyer/orders" element={<BuyerOrders />} />
                  <Route path="/buyer/wishlist" element={<BuyerWishlist />} />
                  <Route path="/buyer/messages" element={<BuyerMessages />} />

                  {/* Specialized Role Dashboards */}
                  <Route path="/seller" element={<SellerDashboard />} />
                  <Route path="/booster" element={<BoosterDashboard />} />
                  <Route path="/admin" element={<AdminDashboard />} />

                  {/* Catch-all fallback */}
                  <Route path="*" element={<Home />} />
                </Routes>
              </main>
              <Footer />
            </div>
          </BrowserRouter>
        </AuthProvider>
      </CurrencyProvider>
    </ThemeProvider>
  );
};
export default App;
